import {minString, maxtring, avgString, GUST, GUST2, litersPerHour, litersPerDay} from "../constants/sensors-constants";

export default {
    methods: {
        /**
         * Checks if locale string exists and return translation.
         * If not, return original name of sensor.
         * @param {string} input
         * @returns {VueI18n.TranslateResult|*}
         */
        safeGetTooltip(input) {
            // the series names from BE
            let itemName = input;
            // Min, Max, Avg
            let suffix = "";

            // eventual translations
            let itemNameTranslation = itemName;
            let suffixTranslation = suffix;

            // flags - if found suffix
            let foundSuffix = false;

            // The i18n does not handle dots in key and returns error
            if ([GUST.toLowerCase(), GUST2.toLowerCase()].includes(itemName.toLowerCase())) {
                itemName = 'wind-speed'
            }

            /*
             * Check if min, max or avg in name
             * If yes, separate and convert both, then concatenate.
             * Idea is: do not create N count of translations,
             * as we may have multiple triple data items!
             */
            for (let suffixConstant of [minString, maxtring, avgString, litersPerHour, litersPerDay]) {
                if (itemName.toLowerCase().includes(suffixConstant)) {
                    foundSuffix = true;
                    break;
                }
            }

            if (foundSuffix) {
                const nameParts = itemName.split("-");
                itemName = nameParts[0];
                suffix = nameParts[1];
            }

            if (this.$i18n.te(`sensors.${itemName}`)) {
                itemNameTranslation = this.$i18n.t(`sensors.${itemName}`);
            }
            if (suffix && this.$i18n.te(`sensors.suffix.${suffix}`)) {
                suffixTranslation = this.$i18n.t(`sensors.suffix.${suffix}`);
            }

            if (suffixTranslation) {
                return `${itemNameTranslation} ${suffixTranslation}`;
            }
            return itemNameTranslation;
        },
        /**
         * Goes through the series (chart data items) and floss the names.
         *
         * @param {Object[]} series
         * @returns {*}
         */
        beautifySeriesNames(series) {
            for (let item of series) {
                // we may need the original name for later, so save it
                item.originalName = item.name;
                item.name = this.safeGetTooltip(item.name);
            }
            return series;
        }
    }
};